import React, { useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { formateDateFilter, formatDisplayDate } from "../../shared/dateFormat";
import { useEffect } from "react";
import useStyles from "../styles";

const DateTimeWidget = (props) => {
  const {
    id,
    name,
    value,
    onChange,
    disabled,
    error,
    required,
    onAccept,
    helpText,
    disablePast,
    disableFuture,
    minDate,
    maxDate,
  } = props;
  delete props.children;
  const [deafult, setDefault] = useState(null);
  const [errorMeesage, setErrorMeesage] = useState("");
  const classes = useStyles();

  useEffect(() => {
    setDefault(value ? formatDisplayDate(value) : null);
    setErrorMeesage("");
  }, [value]);

  const handleDateChange = (e, date) => {
    let body = {
      name: name,
      id: id,
      value: date ? formateDateFilter(e) : null,
    };

    if (e && e.toString() === "Invalid Date") {
      setDefault(body.value);
      // setErrorMeesage("Please enter valid date");
    } else {
      if (onChange) {
        setDefault(body.value);
        onChange(body, "date", e);
        setErrorMeesage("");
      }
    }
  };
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <>
        <KeyboardDatePicker
          autoOk
          margin="normal"
          id={id}
          name={name}
          size="small"
          format="MM/dd/yyyy"
          value={deafult}
          disabled={disabled}
          onChange={handleDateChange}
          fullWidth
          style={{ borderBottom: error ? "solid 1px red" : "none" }}
          onBlur={onAccept}
          KeyboardButtonProps={{
            "aria-label": "change date",
          }}
          required={required}
          helperText={helpText ? helpText : errorMeesage}
          disablePast={disablePast}
          disableFuture={disableFuture}
          minDate={minDate}
          maxDate={maxDate}
          className="form__input-date"
          variant="inline"
          classes={{
            root: error
              ? ""
              : disabled
              ? classes.disabledInput
              : classes.editableInput,
          }}
        />
      </>
    </MuiPickersUtilsProvider>
  );
};
export default DateTimeWidget;
